import { NgModule } from '@angular/core';
import { TVErrorCodesRoutingModule } from './tv-error-codes-routing.module';

@NgModule({
  declarations: [],
  exports: [],
  providers: [],
  imports: [TVErrorCodesRoutingModule],
})
export class TVErrorCodesModule {}
